import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CheckboxTickIcon, DeleteIcon, px2rem } from 'react-onei';
import UserContext from '../../../context/UserContext';

const Container = styled('div')`
  margin: ${px2rem(11)} ${px2rem(0)} ${px2rem(0)} ${px2rem(11)};
`;

const TextContainer = styled('div')`
  display: flex;
  align-items: center;
`;

const Text = styled('p')`
  font-family: o-HelveticaNeue, Arial, sans-serif;
  font-weight: 400;
  font-size: ${px2rem(14)};
  line-height: ${px2rem(20)};
  margin: ${px2rem(3)} ${px2rem(0)} ${px2rem(3)} ${px2rem(17)};
`;

const hasCorrectLength = (value) => value.length >= 8;

const hasLowerCase = (value) => (/[a-z]/g).test(value);

const hasUpperCase = (value) => (/[A-Z]/g).test(value);

const hasNumber = (value) => (/\d/g).test(value);

function PasswordValidity(props) {
  const { value, touched } = props;
  const successColor = !touched ? 'functionalSuccess' : 'grey1';
  const errorColor = !touched ? 'functionalError' : 'grey1';
  const { wording } = useContext(UserContext);
  const { WLOST_414, WLOST_415, WLOST_416, WLOST_417 } = wording;

  return (
    <Container id="cnil-rules">
      <TextContainer id="cnil-rule-length">
        {hasCorrectLength(value) || touched ?
          <CheckboxTickIcon id="cnil-icon-length-ok" size={16} color={successColor} /> :
          <DeleteIcon id="cnil-icon-length-ko" size={16} color={errorColor} />}
        <Text id="cnil-rule-length-label">{WLOST_414}</Text>
      </TextContainer>

      <TextContainer id="cnil-rule-lowercase">
        {hasLowerCase(value) || touched ?
          <CheckboxTickIcon id="cnil-icon-lowercase-ok" size={16} color={successColor} /> :
          <DeleteIcon id="cnil-icon-lowercase-ko" size={16} color={errorColor} />}
        <Text id="cnil-rule-lowercase-label">{WLOST_415}</Text>
      </TextContainer>

      <TextContainer id="cnil-rule-uppercase">
        {hasUpperCase(value) || touched ?
          <CheckboxTickIcon id="cnil-icon-uppercase-ok" size={16} color={successColor} /> :
          <DeleteIcon id="cnil-icon-uppercase-ko" size={16} color={errorColor} />}
        <Text id="cnil-rule-uppercase-label">{WLOST_416}</Text>
      </TextContainer>

      <TextContainer id="cnil-rule-number">
        {hasNumber(value) || touched ?
          <CheckboxTickIcon id="cnil-icon-number-ok" size={16} color={successColor} /> :
          <DeleteIcon id="cnil-icon-number-ko" size={16} color={errorColor} />}
        <Text id="cnil-rule-number-label">{WLOST_417}</Text>
      </TextContainer>
    </Container>
  );
}

PasswordValidity.validate = (value) => (
  hasCorrectLength(value) && hasLowerCase(value) && hasUpperCase(value) && hasNumber(value)
);

PasswordValidity.propTypes = {
  value: PropTypes.string.isRequired,
  touched: PropTypes.bool.isRequired,
};

export default PasswordValidity;
